import { getColor, getBorderColor, getBackgroundColor, getOutlineColor, } from '../../colors/colors.alias';
import { getBorderWidth, getBorderRadius, getBorderStyle, getOutlineWidth, getOutlineStyle, getOutlineOffset, } from '../../borders/borders.alias';
import { getWidth, getHeight } from '../../sizes/sizes.alias';
import { getFontWeight, getFontFamily, getFontSize, getLineHeight, } from '../../typography/typography.alias';
import { VARIANT_DEFAULT, ELEMENT_DATE, INTERACTION_STATE_HOVER, INTERACTION_STATE_FOCUS_VISIBLE, DATA_STATE_SELECTED, DATA_STATE_UNAVAILABLE, DATA_STATE_IS_TODAY, DATA_STATE_TODAY_SELECTED, DATA_STATE_IS_IN_DATE_RANGE, } from '../../constants';
export const constants = Object.freeze({
    NAME: 'DatepickerDate',
    variants: {
        VARIANT_DEFAULT,
    },
    elements: {
        ELEMENT_DATE,
    },
    interactionStates: {
        INTERACTION_STATE_HOVER,
        INTERACTION_STATE_FOCUS_VISIBLE,
    },
    dataStates: {
        DATA_STATE_SELECTED,
        DATA_STATE_UNAVAILABLE,
        DATA_STATE_IS_TODAY,
        DATA_STATE_TODAY_SELECTED,
        DATA_STATE_IS_IN_DATE_RANGE,
    },
});
export default function getDatepickerDate(transformer, config) {
    const borderStyle = getBorderStyle(transformer, config);
    const borderColor = getBorderColor(transformer, config);
    const borderWidth = getBorderWidth(transformer, config);
    const backgroundColor = getBackgroundColor(transformer, config);
    const color = getColor(transformer, config);
    const fontFamily = getFontFamily(transformer, config);
    const fontSize = getFontSize(transformer);
    const lineHeight = getLineHeight(transformer);
    const height = getHeight(transformer);
    const outlineOffset = getOutlineOffset(transformer, config);
    const outlineWidth = getOutlineWidth(transformer, config);
    const outlineColor = getOutlineColor(transformer, config);
    const outlineStyle = getOutlineStyle(transformer, config);
    const borderRadius = getBorderRadius(transformer, config);
    const width = getWidth(transformer);
    const fontWeight = getFontWeight(transformer);
    return Object.freeze({
        constants,
        elements: {
            [ELEMENT_DATE]: {
                styles: {
                    fontFamily: fontFamily.body.value,
                    fontSize: fontSize.form.datepicker.date.value,
                    lineHeight: lineHeight.body.get(fontSize.form.datepicker.date.value),
                    color: color.text.default.value,
                    height: height.circle.m.value,
                    width: width.circle.m.value,
                    borderRadius: borderRadius.circle.value,
                    borderWidth: borderWidth.form.datepicker.date.value,
                    borderStyle: borderStyle.form.datepicker.date.value,
                    borderColor: borderColor.form.datepicker.date.default.value,
                },
                interactionStates: {
                    [INTERACTION_STATE_HOVER]: {
                        styles: {
                            borderColor: borderColor.form.datepicker.date.interactionStates[INTERACTION_STATE_HOVER].value,
                            backgroundColor: backgroundColor.form.datepicker.date.interactionStates[INTERACTION_STATE_HOVER].value,
                        },
                    },
                    [INTERACTION_STATE_FOCUS_VISIBLE]: {
                        styles: {
                            outlineWidth: outlineWidth.default.value,
                            outlineStyle: outlineStyle.default.value,
                            outlineOffset: outlineOffset.default.value,
                            outlineColor: outlineColor.default.interactionStates[INTERACTION_STATE_FOCUS_VISIBLE].value,
                        },
                    },
                },
                dataStates: {
                    [DATA_STATE_UNAVAILABLE]: {
                        styles: {
                            color: color.form.datepicker.date.dataStates[DATA_STATE_UNAVAILABLE]
                                .value,
                        },
                    },
                    [DATA_STATE_SELECTED]: {
                        styles: {
                            borderColor: borderColor.form.datepicker.date.dataStates[DATA_STATE_SELECTED]
                                .value,
                            backgroundColor: backgroundColor.form.datepicker.date.dataStates[DATA_STATE_SELECTED].value,
                            fontFamily: fontFamily.form.datepicker.date.dataStates[DATA_STATE_SELECTED]
                                .value,
                            fontWeight: fontWeight.form.datepicker.date.dataStates[DATA_STATE_SELECTED].get(fontFamily.form.datepicker.date.dataStates[DATA_STATE_SELECTED]
                                .value),
                            color: color.form.datepicker.date.dataStates[DATA_STATE_SELECTED]
                                .value,
                        },
                    },
                    [DATA_STATE_IS_TODAY]: {
                        styles: {
                            borderColor: borderColor.form.datepicker.date.dataStates[DATA_STATE_IS_TODAY]
                                .value,
                        },
                    },
                    [DATA_STATE_TODAY_SELECTED]: {
                        styles: {
                            borderColor: borderColor.form.datepicker.date.dataStates[DATA_STATE_IS_TODAY]
                                .value,
                            backgroundColor: backgroundColor.form.datepicker.date.dataStates[DATA_STATE_SELECTED].value,
                            fontFamily: fontFamily.form.datepicker.date.dataStates[DATA_STATE_SELECTED]
                                .value,
                            fontWeight: fontWeight.form.datepicker.date.dataStates[DATA_STATE_SELECTED].get(fontFamily.form.datepicker.date.dataStates[DATA_STATE_SELECTED]
                                .value),
                            color: color.form.datepicker.date.dataStates[DATA_STATE_SELECTED]
                                .value,
                        },
                    },
                    [DATA_STATE_IS_IN_DATE_RANGE]: {
                        styles: {
                            backgroundColor: backgroundColor.form.datepicker.date.dataStates[DATA_STATE_IS_IN_DATE_RANGE].value,
                        },
                    },
                },
            },
        },
    });
}
